import React from 'react';
import ZoneIntervention from '../components/ZoneIntervention';

function Zone78() {
    const cities = [
        "Antiquaire Ablis 78660",
        "Antiquaire Achères 78260",
        "Antiquaire Adainville 78113",
        "Antiquaire Aigremont 78240",
        "Antiquaire Allainville 78660",
        "Antiquaire Andelu 78770",
        "Antiquaire Andrésy 78570",
        "Antiquaire Arnouville-lès-Mantes 78790",
        "Antiquaire Aubergenville 78410",
        "Antiquaire Auffargis 78610",
        "Antiquaire Auffreville-Brasseuil 78930",
        "Antiquaire Aulnay-sur-Mauldre 78126",
        "Antiquaire Auteuil 78770",
        "Antiquaire Autouillet 78770",

        "Antiquaire Bailly 78870",
        "Antiquaire Bazainville 78550",
        "Antiquaire Bazemont 78580",
        "Antiquaire Bazoches-sur-Guyonne 78490",
        "Antiquaire Béhoust 78910",
        "Antiquaire Bennecourt 78270",
        "Antiquaire Beynes 78650",
        "Antiquaire Blaru 78270",
        "Antiquaire Boinville-en-Mantois 78930",
        "Antiquaire Boinville-le-Gaillard 78660",
        "Antiquaire Boinvilliers 78200",
        "Antiquaire Bois-d’Arcy 78390",
        "Antiquaire Boissets 78910",
        "Antiquaire Boissy-Mauvoisin 78200",
        "Antiquaire Boissy-sans-Avoir 78490",
        "Antiquaire Bonnelles 78830",
        "Antiquaire Bonnières-sur-Seine 78270",
        "Antiquaire Bouafle 78410",
        "Antiquaire Bougival 78380",
        "Antiquaire Bourdonné 78113",
        "Antiquaire Breuil-Bois-Robert 78930",
        "Antiquaire Bréval 78980",
        "Antiquaire Brueil-en-Vexin 78440",
        "Antiquaire Buc 78530",
        "Antiquaire Buchelay 78200",
        "Antiquaire Bullion 78830",

        "Antiquaire Carrières-sous-Poissy 78955",
        "Antiquaire Carrières-sur-Seine 78420",
        "Antiquaire Cernay-la-Ville 78720",
        "Antiquaire Chambourcy 78240",
        "Antiquaire Chanteloup-les-Vignes 78570",
        "Antiquaire Chapet 78130",
        "Antiquaire Châteaufort 78117",
        "Antiquaire Chatou 78400",
        "Antiquaire Chaufour-lès-Bonnières 78270",
        "Antiquaire Chavenay 78450",
        "Antiquaire Chevreuse 78460",
        "Antiquaire Choisel 78460",
        "Antiquaire Civry-la-Forêt 78910",
        "Antiquaire Clairefontaine-en-Yvelines 78120",
        "Antiquaire Coignières 78310",
        "Antiquaire Condé-sur-Vesgre 78113",
        "Antiquaire Conflans-Sainte-Honorine 78700",
        "Antiquaire Courgent 78790",
        "Antiquaire Cravent 78270",
        "Antiquaire Crespières 78121",
        "Antiquaire Croissy-sur-Seine 78290",

        "Antiquaire Dammartin-en-Serve 78111",
        "Antiquaire Dampierre-en-Yvelines 78720",
        "Antiquaire Dannemarie 78550",
        "Antiquaire Davron 78810",
        "Antiquaire Drocourt 78440",

        "Antiquaire Ecquevilly 78920",
        "Antiquaire Élancourt 78990",
        "Antiquaire Émancé 78125",
        "Antiquaire Épône 78680",
        "Antiquaire Évecquemont 78740",

        "Antiquaire Favrieux 78200",
        "Antiquaire Feucherolles 78810",
        "Antiquaire Flacourt 78200",
        "Antiquaire Flexanville 78910",
        "Antiquaire Flins-Neuve-Église 78790",
        "Antiquaire Flins-sur-Seine 78410",
        "Antiquaire Follainville-Dennemont 78520",
        "Antiquaire Fontenay-le-Fleury 78330",
        "Antiquaire Fontenay-Mauvoisin 78200",
        "Antiquaire Fontenay-Saint-Père 78440",
        "Antiquaire Freneuse 78840",
        "Antiquaire Gaillon-sur-Montcient 78250",
        "Antiquaire Galluis 78490",
        "Antiquaire Gambais 78950",
        "Antiquaire Gambaiseuil 78490",
        "Antiquaire Garancières 78890",
        "Antiquaire Gargenville 78440",
        "Antiquaire Gazeran 78125",
        "Antiquaire Gommecourt 78270",
        "Antiquaire Goupillières 78770",
        "Antiquaire Goussonville 78930",
        "Antiquaire Grandchamp 78113",
        "Antiquaire Gressey 78550",
        "Antiquaire Grosrouvre 78490",
        "Antiquaire Guernes 78520",
        "Antiquaire Guerville 78930",
        "Antiquaire Guitrancourt 78440",
        "Antiquaire Guyancourt 78280",
        "Antiquaire Hardricourt 78250",
        "Antiquaire Hargeville 78790",
        "Antiquaire Herbeville 78580",
        "Antiquaire Hermeray 78125",
        "Antiquaire Houdan 78550",
        "Antiquaire Houilles 78800",
        "Antiquaire Issou 78440",
        "Antiquaire Jambville 78440",
        "Antiquaire Jouars-Pontchartrain 78760",
        "Antiquaire Jouy-en-Josas 78350",
        "Antiquaire Jouy-Mauvoisin 78200",
        "Antiquaire Jumeauville 78580",
        "Antiquaire Juziers 78820",
        "Antiquaire L’Étang-la-Ville 78620",
        "Antiquaire La Boissière-École 78125",
        "Antiquaire La Celle-les-Bordes 78720",
        "Antiquaire La Celle-Saint-Cloud 78170",
        "Antiquaire La Falaise 78410",
        "Antiquaire La Hauteville 78113",
        "Antiquaire La Queue-les-Yvelines 78940",
        "Antiquaire La Verrière 78320",
        "Antiquaire La Villeneuve-en-Chevrie 78270",
        "Antiquaire Lainville-en-Vexin 78440",
        "Antiquaire Le Chesnay-Rocquencourt 78150",
        "Antiquaire Le Mesnil-le-Roi 78600",
        "Antiquaire Le Mesnil-Saint-Denis 78320",
        "Antiquaire Le Pecq 78230",
        "Antiquaire Le Perray-en-Yvelines 78610",
        "Antiquaire Le Port-Marly 78560",
        "Antiquaire Le Tartre-Gaudran 78113",
        "Antiquaire Le Tertre-Saint-Denis 78980",
        "Antiquaire Le Tremblay-sur-Mauldre 78490",
        "Antiquaire Le Vésinet 78110",
        "Antiquaire Les Alluets-le-Roi 78580",
        "Antiquaire Les Bréviaires 78610",
        "Antiquaire Les Clayes-sous-Bois 78340",
        "Antiquaire Les Essarts-le-Roi 78690",
        "Antiquaire Les Loges-en-Josas 78350",
        "Antiquaire Les Mesnuls 78490",
        "Antiquaire Les Mureaux 78130",
        "Antiquaire Lévis-Saint-Nom 78320",
        "Antiquaire Limay 78520",
        "Antiquaire Limetz-Villez 78270",
        "Antiquaire Lommoye 78270",
        "Antiquaire Longnes 78980",
        "Antiquaire Longvilliers 78730",
        "Antiquaire Louveciennes 78430",
        "Antiquaire Magnanville 78200",
        "Antiquaire Magny-les-Hameaux 78114",
        "Antiquaire Maisons-Laffitte 78600",
        "Antiquaire Mantes-la-Jolie 78200",
        "Antiquaire Mantes-la-Ville 78711",
        "Antiquaire Marcq 78770",
        "Antiquaire Mareil-le-Guyon 78490",
        "Antiquaire Mareil-Marly 78750",
        "Antiquaire Mareil-sur-Mauldre 78124",
        "Antiquaire Marly-le-Roi 78160",
        "Antiquaire Maule 78580",
        "Antiquaire Maulette 78550",
        "Antiquaire Maurecourt 78780",
        "Antiquaire Maurepas 78310",
        "Antiquaire Médan 78670",
        "Antiquaire Ménerville 78200",
        "Antiquaire Méré 78490",
        "Antiquaire Méricourt 78270",
        "Antiquaire Meulan-en-Yvelines 78250",
        "Antiquaire Mézières-sur-Seine 78970",
        "Antiquaire Mézy-sur-Seine 78250",
        "Antiquaire Millemont 78940",
        "Antiquaire Milon-la-Chapelle 78470",
        "Antiquaire Mittainville 78125",
        "Antiquaire Moisson 78840",
        "Antiquaire Mondreville 78980",
        "Antiquaire Montainville 78124",
        "Antiquaire Montalet-le-Bois 78440",
        "Antiquaire Montchauvet 78790",
        "Antiquaire Montesson 78360",
        "Antiquaire Montfort-l’Amaury 78490",
        "Antiquaire Montigny-le-Bretonneux 78180",
        "Antiquaire Morainvilliers 78630",
        "Antiquaire Mousseaux-sur-Seine 78270",
        "Antiquaire Mulcent 78790",
        "Antiquaire Neauphle-le-Château 78640",
        "Antiquaire Neauphle-le-Vieux 78640",
        "Antiquaire Neauphlette 78980",
        "Antiquaire Nézel 78410",
        "Antiquaire Noisy-le-Roi 78590",
        "Antiquaire Notre-Dame-de-la-Mer 78270",
        "Antiquaire Oinville-sur-Montcient 78250",
        "Antiquaire Orcemont 78125",
        "Antiquaire Orgerus 78910",
        "Antiquaire Orgeval 78630",
        "Antiquaire Orphin 78125",
        "Antiquaire Orsonville 78660",
        "Antiquaire Orvilliers 78910",
        "Antiquaire Osmoy 78910",
        "Antiquaire Paray-Douaville 78660",
        "Antiquaire Perdreauville 78200",
        "Antiquaire Plaisir 78370",
        "Antiquaire Poigny-la-Forêt 78125",
        "Antiquaire Poissy 78300",
        "Antiquaire Ponthévrard 78730",
        "Antiquaire Porcheville 78440",
        "Antiquaire Prunay-en-Yvelines 78660",
        "Antiquaire Prunay-le-Temple 78910",
        "Antiquaire Raizeux 78125",
        "Antiquaire Rambouillet 78120",
        "Antiquaire Rennemoulin 78590",
        "Antiquaire Richebourg 78550",
        "Antiquaire Rochefort-en-Yvelines 78730",
        "Antiquaire Rolleboise 78270",
        "Antiquaire Rosay 78790",
        "Antiquaire Rosny-sur-Seine 78710",
        "Antiquaire Sailly 78440",
        "Antiquaire Saint-Arnoult-en-Yvelines 78730",
        "Antiquaire Saint-Cyr-l’École 78210",
        "Antiquaire Saint-Forget 78720",
        "Antiquaire Saint-Germain-de-la-Grange 78640",
        "Antiquaire Saint-Germain-en-Laye 78100",
        "Antiquaire Saint-Hilarion 78125",
        "Antiquaire Saint-Illiers-la-Ville 78980",
        "Antiquaire Saint-Illiers-le-Bois 78980",
        "Antiquaire Saint-Lambert 78470",
        "Antiquaire Saint-Léger-en-Yvelines 78610",
        "Antiquaire Saint-Martin-de-Bréthencourt 78660",
        "Antiquaire Saint-Martin-des-Champs 78790",
        "Antiquaire Saint-Martin-la-Garenne 78520",
        "Antiquaire Saint-Nom-la-Bretèche 78860",
        "Antiquaire Saint-Rémy-l’Honoré 78690",
        "Antiquaire Saint-Rémy-lès-Chevreuse 78470",
        "Antiquaire Sainte-Mesme 78730",
        "Antiquaire Sartrouville 78500",
        "Antiquaire Saulx-Marchais 78650",
        "Antiquaire Senlisse 78720",
        "Antiquaire Septeuil 78790",
        "Antiquaire Soindres 78200",
        "Antiquaire Sonchamp 78120",
        "Antiquaire Tacoignières 78910",
        "Antiquaire Tessancourt-sur-Aubette 78250",
        "Antiquaire Thiverval-Grignon 78850",
        "Antiquaire Thoiry 78770",
        "Antiquaire Tilly 78790",
        "Antiquaire Toussus-le-Noble 78117",
        "Antiquaire Trappes 78190",
        "Antiquaire Triel-sur-Seine 78510",
        "Antiquaire Vaux-sur-Seine 78740",
        "Antiquaire Vélizy-Villacoublay 78140",
        "Antiquaire Verneuil-sur-Seine 78480",
        "Antiquaire Vernouillet 78540",
        "Antiquaire Versailles 78000",
        "Antiquaire Vert 78930",
        "Antiquaire Vicq 78490",
        "Antiquaire Vieille-Église-en-Yvelines 78125",
        "Antiquaire Villennes-sur-Seine 78670",
        "Antiquaire Villepreux 78450",
        "Antiquaire Villette 78930",
        "Antiquaire Villiers-le-Mahieu 78770",
        "Antiquaire Villiers-Saint-Frédéric 78640",
        "Antiquaire Viroflay 78220",
        "Antiquaire Voisins-le-Bretonneux 78960"
    ];
    return <ZoneIntervention departmentName="Yvelines (78)" cities={cities} />;
}

export default Zone78;
